import React from "react";

const Spinner = () => {
  return (
    <div className="flex justify-center items-center  pt-[10%]">
      <div className="w-28 h-28 border-l-2 border-[#57a330] rounded-full animate-spin"></div>
    </div>
  );
};

export default Spinner;
